import { BoxInput } from '@monthio/react-components'
import { FunctionComponent, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
	BoxInputWrapper,
	StyledBodyFlow,
} from '../styledMissingBudgetInfoComponents'
import {
	isBudgetValueValid,
	MissingInfoBudgetKey,
} from '../missingBudgetInfoUtils'
import { budgetEstimatesCalculatorService } from '../../BudgetOverview/budgetEstimatesCalculatorService'
import { applySignBySection } from '../../BudgetOverview/budgetEstimatesUtils'

export const MissingInfoInput: FunctionComponent<{
	budgetKey: MissingInfoBudgetKey
	noInfoConfirmed?: boolean
	handleChange?: () => void
}> = ({ budgetKey, noInfoConfirmed = false, handleChange }) => {
	const { t } = useTranslation()
	const [currentValue, setCurrentValue] = useState(
		budgetEstimatesCalculatorService.getValue(budgetKey),
	)
	const [isValueValid, setIsValueValid] = useState(false)

	const getSection = (budgetKey: string) =>
		budgetKey.startsWith('tree.income') ? 'tree.income' : 'tree.expenses'

	const handleInputChange = useCallback(
		(event) => {
			const newValue = Math.abs(event.target.value)
			setCurrentValue(newValue)
			handleChange && handleChange()

			const valueWithSign = applySignBySection(getSection(budgetKey), newValue)
			budgetEstimatesCalculatorService.update(budgetKey, valueWithSign)
		},
		[budgetKey, handleChange],
	)

	useEffect(() => {
		return budgetEstimatesCalculatorService.subscribe((key) => {
			if (key === budgetKey) {
				setCurrentValue(
					Math.abs(budgetEstimatesCalculatorService.getValue(key)),
				)
				setIsValueValid(
					isBudgetValueValid(
						budgetKey,
						budgetEstimatesCalculatorService.getEstimates(),
						false,
					),
				)
			}
		})
	}, [budgetKey])

	return (
		<BoxInputWrapper>
			<StyledBodyFlow>
				{t(`miniBudgetFormV2-missingInfo-${budgetKey}-inputText`)}
			</StyledBodyFlow>
			<BoxInput
				value={currentValue}
				onChange={handleInputChange}
				currencyInputProps={{
					allowNegativeValue: false,
					allowDecimals: false,
					maxLength: 8,
				}}
				error={!isValueValid && !noInfoConfirmed}
			/>
		</BoxInputWrapper>
	)
}

// miniBudgetFormV2-missingInfo-tree.expenses.housing.rent-inputText
// miniBudgetFormV2-missingInfo-tree.expenses.others.insurance-inputText
// miniBudgetFormV2-missingInfo-tree.expenses.housing.rent-inputTooltip
// miniBudgetFormV2-missingInfo-tree.expenses.others.insurance-inputTooltip
// miniBudgetFormV2-missingInfo-tree.income.salary-inputText
